import { render, staticRenderFns } from "./PacientesReporteCirugias.vue?vue&type=template&id=579c75b9&"
import script from "./PacientesReporteCirugias.vue?vue&type=script&lang=js&"
export * from "./PacientesReporteCirugias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports